import { Link } from "react-router-dom";
import { useForm, ValidationError } from "@formspree/react";
import styles from "./ContactForm.module.css";

const ContactForm = () => {
  const [state, handleSubmit] = useForm("mpzgzokp");

  if (state.succeeded) {
    return (
      <div className={styles.formspreeMessage}>
        <p id="formbutton-description">Thanks for your message!</p>
        <p id="formbutton-description"> We will contact you ASAP.</p>
        <Link className={`primary-btn ${styles.formBtn}`} to="/">
          Back To Home
        </Link>
      </div>
    );
  }

  // The code below to submit the form in case the project switch from using Formspree to backend setup.

  // const initialFormData = {
  //   name: "",
  //   email: "",
  //   message: "",
  // };

  // const [formData, setFormData] = useState(initialFormData);

  // const { name, email, message } = formData;

  // const onChange = (e) => {
  //   setFormData((prevState) => ({
  //     ...prevState,
  //     [e.target.id]: e.target.value,
  //   }));
  // };

  // const submit = async (e) => {
  //   e.preventDefault();
  //   console.log(formData);
  //   setFormData(initialFormData);
  // };

  return (
    <div>
      <div className={styles.contactContainer}>
        <div className="section">
          <div className={styles.contactSection}>
            <div className={styles.touch}>
              {state.succeeded
                ? ""
                : " We'd love to hear from you - get in touch using our contact form"}
            </div>
            <form
              action="https://formspree.io/f/mpzgzokp"
              className={styles.formContainer}
              onSubmit={handleSubmit}
              method="POST"
            >
              <div className={styles.fieldsWrapper}>
                <label htmlFor="name">Full Name</label>
                <input
                  type="text"
                  name="name"
                  id="name"
                  placeholder="Name"
                  // value={name}
                  // onChange={onChange}
                  required
                />
                <ValidationError
                  prefix="Name"
                  field="name"
                  errors={state.errors}
                />
              </div>
              <div className={styles.fieldsWrapper}>
                <label htmlFor="email">Your Email</label>
                <input
                  type="email"
                  name="email"
                  id="email"
                  placeholder="Email"
                  // value={email}
                  // onChange={onChange}
                  required
                />
                <ValidationError
                  prefix="Email"
                  field="email"
                  errors={state.errors}
                />
              </div>
              <div className={styles.fieldsWrapper}>
                <label htmlFor="message">Your Message</label>
                <textarea
                  type="text"
                  name="message"
                  id="message"
                  placeholder="Message"
                  // value={message}
                  // onChange={onChange}
                  required
                />
                <ValidationError
                  prefix="Message"
                  field="message"
                  errors={state.errors}
                />
              </div>
              <button
                type="submit"
                className={`primary-btn ${styles.submitBtn}`}
                disabled={state.submitting}
              >
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ContactForm;
